import { Avatar, Box, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { Item } from "../Item";
import Logout from "@mui/icons-material/Logout";
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../constants";

const UserMenuButton = () => {
  const { user, logout } = useAuth0();
  let history = useHistory();

  const logoutWithRedirect = () => logout({ returnTo: window.location.origin });

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const routeToOrganizationPicker = () => {
    handleClose();
    history.push(ROUTES.ORGANIZATIONS);
  };

  return (
    <div>
      <Box onClick={handleMenu} sx={{ display: "flex" }}>
        <Item>
          <Avatar src={user.picture} />
        </Item>
      </Box>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={routeToOrganizationPicker}>{user.name}</MenuItem>
        <MenuItem onClick={logoutWithRedirect}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

export default UserMenuButton;
